import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Loader.css';
import React, { useContext, useState, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { get, getPageThemeColors, canUseDOM } from '../../../utils';
var Loader = function Loader(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var colorFallback = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  var variables = {
    "--loader-color": props.color ? props.color : colorFallback
  };
  return /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-component ".concat(commonStyles)
  }));
};
var commonStyles = "c17ozkk4";
export default Loader;